const CATEGORY_PRIORITY = [
  "conference",
  "cours",
  "concours",
  "atelier",
  "divers",
  "dons",
  "janaza",
  "projet",
  "rencontre",
  "annonces",
];

const normalizeCategory = (category = "") =>
  String(category)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const getCategoryPriority = (category = "") => {
  const normalized = normalizeCategory(category);
  if (normalized.startsWith("conference")) return CATEGORY_PRIORITY.indexOf("conference");
  if (normalized.startsWith("cours")) return CATEGORY_PRIORITY.indexOf("cours");
  if (normalized.startsWith("concours")) return CATEGORY_PRIORITY.indexOf("concours");
  if (normalized.startsWith("atelier")) return CATEGORY_PRIORITY.indexOf("atelier");
  if (normalized.startsWith("divers")) return CATEGORY_PRIORITY.indexOf("divers");
  if (normalized.startsWith("don")) return CATEGORY_PRIORITY.indexOf("dons");
  if (normalized.startsWith("janaza")) return CATEGORY_PRIORITY.indexOf("janaza");
  if (normalized.startsWith("projet")) return CATEGORY_PRIORITY.indexOf("projet");
  if (normalized.startsWith("rencontre")) return CATEGORY_PRIORITY.indexOf("rencontre");
  if (normalized.startsWith("annonce")) return CATEGORY_PRIORITY.indexOf("annonces");
  return Number.MAX_SAFE_INTEGER;
};

export const compareCategories = (left, right) => {
  const leftPriority = getCategoryPriority(left);
  const rightPriority = getCategoryPriority(right);
  if (leftPriority !== rightPriority) {
    return leftPriority - rightPriority;
  }
  return String(left || "").localeCompare(String(right || ""), "fr", { sensitivity: "base" });
};

export const sortEventsByCategoryPriority = (eventsList = []) =>
  [...eventsList].sort((left, right) => compareCategories(left?.category, right?.category));
